import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import {
	PetitionDetailsQRCodeImage,
	type PetitionDetailsQrCodeImageQuery,
	type PetitionDetailsQrCodeImageQueryVariables,
} from './getPetitionQRCodeImage.graphql';

export type PetitionDetailsQRCodeImageResult = NonNullable<
	NonNullable<PetitionDetailsQrCodeImageQuery['petition']>['qrCode']
>;

export async function getPetitionQRCodeImage({
	slugOrId,
	type,
	size,
	utilityContext,
}: {
	slugOrId: string;
	type: QrCodeType;
	size?: number;
	utilityContext: UtilityContext;
}): Promise<PetitionDetailsQRCodeImageResult> {
	const { data } = await utilityContext.gql.fetch<
		PetitionDetailsQrCodeImageQuery,
		PetitionDetailsQrCodeImageQueryVariables
	>({
		query: PetitionDetailsQRCodeImage,
		variables: { slugOrId, qrCodeType: type, size: size ?? null },
		rejectOnError: true,
	});

	if (!data.petition) throw new Error('Petition not found');
	if (!data.petition.qrCode) throw new Error('QR code not found');

	return data.petition.qrCode;
}
